export default {
      id: "oc-res-nas-usage",
      viewBox: "0 0 1229 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-nas",
      toString: function () {
        return this.url;
      }
    }